import React from 'react';

const CatalogoProdutos = React.createContext();

export default CatalogoProdutos;
